import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Criar conta',
  subtitle: 'Depois do cadastro, você conta sobre a sua organização.',
  firstName: 'Nome',
  firstNamePlaceholder: 'Seu nome',
  lastName: 'Sobrenome',
  optional: 'Opcional',
  lastNamePlaceholder: 'Seu sobrenome',
  email: 'E-mail',
  emailPlaceholder: 'contato@suaorganizacao.com.br',
  password: 'Senha',
  confirmPassword: 'Confirmar senha',
  confirmPasswordPlaceholder: 'Repita a senha',
  hidePassword: 'Ocultar senha',
  showPassword: 'Mostrar senha',
  marketingOptIn: 'Quero receber atualizações por e-mail.',
  acceptPrivacyLead: 'Li e aceito a ',
  privacyPolicy: 'Política de Privacidade',
  submit: 'Criar conta',
  activationEmailNote: 'Após criar a conta, você recebe um e-mail para ativá-la.',
} satisfies TranslationTree;
